var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor youtube-reply-comment" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.youTubeReplyCommentChannelId"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "YouTube Channel ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "channelId", $$v)
            },
            expression: "clone.channelId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.youTubeReplyCommentYanTVerilecekYorumunBulunduUKanalIdsi"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.youTubeReplyCommentCommentId"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "YouTube Comment ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.commentId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "commentId", $$v)
            },
            expression: "clone.commentId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(_vm.$t("auto.youTubeReplyCommentYanTVerilecekYorumunIdsi"))
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.youTubeReplyCommentYanTMetni"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Yanıt metni giriniz...",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.text,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "text", $$v)
            },
            expression: "clone.text",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }